import { render, staticRenderFns } from "./EnvolvidoProcessos.vue?vue&type=template&id=8652fc8e&scoped=true&"
import script from "./EnvolvidoProcessos.vue?vue&type=script&lang=js&"
export * from "./EnvolvidoProcessos.vue?vue&type=script&lang=js&"
import style0 from "./EnvolvidoProcessos.vue?vue&type=style&index=0&id=8652fc8e&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8652fc8e",
  null
  
)

export default component.exports